import axios from 'axios'
import Vue from 'vue';
// import { Message } from 'element-ui'
// import router from '@/router';
import { Toast } from 'vant'
import { getToken, setToken } from '@/api/tokenManager'
import { jsonlint } from '@/api/jsonlint'

Vue.use(Toast);
// 创建一个axios实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL, // Url = 基础Url+请求Url
    // 当跨域请求时发送cookie
    timeout: 30000 // 请求超时
})

// 请求拦截器
service.interceptors.request.use(

    config => {
        console.log("1 " + process.env.VUE_APP_BASE_URL)
        console.log("2 " + process.env.VUE_APP_BASE_API)

        setToken('xxxxxx') //为达到token固定值，直接设置token其他不做改动
        // 在请求发送之前做什么
        let tokenValue = getToken()
        if (tokenValue) { //判断当前cookie是否存在token如果存在就执行
            config.headers['token'] = tokenValue //config.headers['名字'] = 值
        }

        config.headers['appcode'] = '100001' //直接存储
        return config
    },
    error => {
        // 请求错误时做了什么
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    /**
     * 如果您想获得http信息，如头信息或状态
     * 请返回response => response
    */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data
        const msg = res.msg
        const resultCode = res.resultCode

        //if the custom code is not 20000, it is judged as an error.
        if (resultCode !== "00") {
            Toast({
                message: msg || 'Error',
                type: 'fail',
                duration: 5 * 1000
            })
            // if (resultCode == '1002') {
            //     removeToken();
            //     router.push({ path: '/login' });
            // }
            /*
            // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            if (resultCode === 50008 || resultCode === 50012 || resultCode === 50014) {
                // to re-login
                MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
                    confirmButtonText: 'Re-Login',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('user/resetToken').then(() => {
                        location.reload()
                    })
                })
            }*/
            return Promise.reject(new Error(msg || 'Error'))
        } else {
            console.log(jsonlint.parse(res.data))
            return jsonlint.parse(res.data);

        }
    },
    error => {
        console.log('err' + error) // for debug
        Toast({
            message: '网络错误，请稍后再试',
            type: 'fail',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service